import moment from '@/core/moment-config'

export default function (value, format = 'DD.MM.YYYY') {
  if (value === undefined || value === null) {
    return null
  }
  return moment(value).format(format)
}
